import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Frown, Cloud, BatteryLow, UserX, ZapOff, Heart, Sun, Zap, UserCheck, Leaf } from 'lucide-react';
export function ComparisonTable() {
  const painPoints = [{
    icon: <Frown data-id="element-66" />,
    text: 'Cansado de cargar con lo que no podés soltar.'
  }, {
    icon: <Cloud data-id="element-67" />,
    text: 'Pensamientos que no te dejan en paz.'
  }, {
    icon: <BatteryLow data-id="element-68" />,
    text: 'Ansiedad y agotamiento emocional.'
  }, {
    icon: <UserX data-id="element-69" />,
    text: 'Sentís que te olvidaste de vos.'
  }, {
    icon: <ZapOff data-id="element-70" />,
    text: 'Vivís en automático, sin disfrutar el presente.'
  }];
  const recoveryPoints = [{
    icon: <Heart data-id="element-71" />,
    text: 'Liberá emociones que ya no te sirven.'
  }, {
    icon: <Sun data-id="element-72" />,
    text: 'Recuperá la calma y tu equilibrio interior.'
  }, {
    icon: <Zap data-id="element-73" />,
    text: 'Reconectá con tu energía y bienestar.'
  }, {
    icon: <UserCheck data-id="element-74" />,
    text: 'Volvé a priorizarte todos los días.'
  }, {
    icon: <Leaf data-id="element-75" />,
    text: 'Empezá a vivir más liviano y en paz.'
  }];
  return <section id="dolor" className="py-24 px-4 relative overflow-hidden bg-[#2C2541] pt-[20px] pb-[20px]" data-id="element-76">
      <div className="max-w-7xl mx-auto space-y-[30px]" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-78">
          {/* Pain Points Section */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-79">
            <div className="mb-10" data-id="element-80">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#D9B15F] mb-4 flex items-center gap-3" data-id="element-81">
                💔 Lo que cargás en silencio
              </h2>
              <div className="h-0.5 w-20 bg-[#D9B15F]/30 rounded-full" data-id="element-82" />
            </div>

            <div className="space-y-4" data-id="element-83">
              {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 p-5 rounded-2xl bg-[#3A3158]/30 border border-white/5 hover:border-[#D9B15F]/10 transition-all group" data-id="element-84">
                  <div className="text-[#B99BE8] group-hover:text-[#D9B15F] transition-colors" data-id="element-85">
                    {cloneElement(point.icon as React.ReactElement, {
                  size: 24
                })}
                  </div>
                  <p className="text-[#F8F5F2]/80 text-lg" data-id="element-86">{point.text}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Recovery Section */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-87">
            <div className="mb-10" data-id="element-88">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#D9B15F] mb-4 flex items-center gap-3" data-id="element-89">
                ✨Lo que merecés sentir
              </h2>
              <div className="h-0.5 w-20 bg-[#D9B15F]/30 rounded-full" data-id="element-90" />
            </div>

            <div className="space-y-4" data-id="element-91">
              {recoveryPoints.map((point, index) => <div key={index} className="flex items-center gap-4 p-5 rounded-2xl bg-[#D9B15F]/5 border border-[#D9B15F]/20 hover:border-[#D9B15F]/40 transition-all group shadow-lg shadow-[#D9B15F]/5" data-id="element-92">
                  <div className="text-[#D9B15F]" data-id="element-93">
                    {cloneElement(point.icon as React.ReactElement, {
                  size: 24
                })}
                  </div>
                  <p className="text-[#F8F5F2] text-lg font-medium" data-id="element-94">
                    {point.text}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-24 text-center max-w-3xl mx-auto" data-id="element-95">
          <p className="text-2xl md:text-3xl font-serif italic text-[#D9B15F] mb-4" data-id="element-96">
            No significa que seas débil.
          </p>
          <p className="text-xl text-[#B99BE8]" data-id="element-97">
            Significa que llevás mucho tiempo sosteniendo emociones que nunca
            aprendiste a liberar.
          </p>
        </motion.div>
      </div>

      {/* Wavy Divider */}
      <div className="wave-divider bottom" data-id="element-98">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-99">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-[#3A3158] opacity-20" data-id="element-100"></path>
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-[#2C2541]" data-id="element-101"></path>
        </svg>
      </div>
    </section>;
}